var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEncaminhado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5258 17.3709V15.0547H7.30362C6.08766 15.0547 5.03093 14.6687 4.13343 13.8967C3.23594 13.1247 2.78719 12.1596 2.78719 11.0015C2.78719 9.84349 3.23594 8.87844 4.13343 8.1064C5.03093 7.33437 6.08766 6.94835 7.30362 6.94835H14.5994L11.5884 9.9593L13.2097 11.5806L19 5.79029L13.2097 0L11.5884 1.62128L14.5994 4.63223H7.30362C5.43142 4.63223 3.82462 5.24021 2.4832 6.45617C1.14179 7.67213 0.471077 9.18726 0.471077 11.0015C0.471077 12.8158 1.14179 14.331 2.4832 15.5469C3.82462 16.7629 5.43142 17.3709 7.30362 17.3709H15.5258Z",
    fill: "#325374"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncaminhado);
export default __webpack_public_path__ + "static/media/encaminhado.45c27b745a1644b0486f805a8240675a.svg";
export { ForwardRef as ReactComponent };